import React, { useEffect , useState } from 'react'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

export const NovedadesInterna = (props) => {
    // const novedad = props.match.params.novedad;
    const id = props.match.params.id;

    const [novedadesApi, setNovedadesApi] = useState([]);
    useEffect(() => {
        fetch("/getNovedades")
            .then(res => res.json())
            .then(result => {
                setNovedadesApi(result);
            });
    }, []);

    var novedadesToShow = null;
    if (novedadesApi.length !== 0) {
        novedadesApi.map(nov => {
            if (nov.id == id) {
                novedadesToShow = nov;
            }
        });
    }

    // const _novedadesToShow = novedadesToShow
    // (novedad => {
    //     const year = novedad.created_at.substr(0,4)
    //     const month = novedad.created_at.substr(5,2)
    //     const day = novedad.created_at.substr(8,2)
    //     const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    //     return {...novedad, created_at: `${day} de ${months[+month-1]} ${year}`};
    // })
    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={'/'}>Novedades</Link>
                    </div>
                </div>
            </div>
            <div className="novedadesInterna">
                <div className="novedadesInterna--container">
                    {novedadesToShow != null ? (
                        <div className="novedadesInterna--note">
                            <h2>{novedadesToShow.created_at}</h2>
                            <h1>{novedadesToShow.titulo}</h1>
                            <p>
                                {ReactHtmlParser(novedadesToShow.descripcion)}
                            </p>
                            <img src={novedadesToShow.foto? `/storage/novedades/${novedadesToShow.id}/${novedadesToShow.hash_foto}`:null} />
                            {novedadesToShow.hash_archivo ?
                                <a download target="_blank" className="btn-novedadHome" href={`storage/novedades/${novedadesToShow.id}/${novedadesToShow.hash_archivo}`}>
                                    <button className="mt-half">Descargar pdf
                                        <img className="ml-half" src='/images/icons/download.svg' />
                                    </button>
                                </a>:null
                            }
                        </div>
                        ): (
                            <div
                                className="spinner-border text-warning mt-base align-self-center justify-content-center"
                                role="status"
                            >
                            </div>
                        )}
                </div>
            </div>
        </div>
    )
}
